import { z } from 'zod';
/**
 * Canonical schema for ADO `git.push` service-hook payloads (§5.4).
 *
 * This is the single source of truth — both the API handler
 * (`marketplace-api/src/modules/webhooks/routes.ts`) and the OpenAPI
 * registry (`packages/marketplace-contracts/src/openapi/registry.ts`)
 * import this schema. Drift between the two surfaces was the bug class
 * that landed this in contracts: an inline copy in the registry that
 * loosened `.min(1)` constraints diverged from the runtime parser and
 * caused the published OpenAPI doc to advertise an under-validated body.
 *
 * Only the fields we route on are validated here — ADO carries more
 * (commits, pushedBy, pipelineRuns) but anything outside this slice is
 * opaque to the webhook handler. The worker (G3-T5) is the canonical
 * consumer of the larger shape.
 *
 * `refUpdates` is allowed to be empty — push events with zero ref
 * changes are an ADO edge case (e.g. tag-only pushes against a branch
 * policy) but we still want the row to round-trip cleanly. The route
 * inspects the first entry's `newObjectId` as the head SHA; missing →
 * we fall back to the empty SHA and let the worker reject downstream.
 *
 * `.min(1)` constraints on every string field guard against ADO
 * delivering empty placeholders during webhook misconfiguration — the
 * runtime parser must reject those before they reach the queue.
 */
export const adoPushPayloadSchema = z
    .object({
    resource: z
        .object({
        repository: z.object({
            id: z.string().min(1),
            name: z.string().min(1),
        }),
        refUpdates: z
            .array(z.object({
            name: z.string().min(1),
            oldObjectId: z.string().min(1),
            newObjectId: z.string().min(1),
        }))
            .default([]),
    })
        .passthrough(),
})
    .passthrough();
/**
 * Reusable response stub for routes that always return `{accepted: true}`.
 * The webhook receiver is the only consumer today; lives here (not the
 * registry) so the OpenAPI registry imports its response shapes from
 * endpoint modules uniformly.
 */
export const webhookAckResponseSchema = z.object({ accepted: z.literal(true) });
//# sourceMappingURL=webhooks.js.map